import ApplicationMarketService from "./service/applicationMarketService";
import override from "src/dectorators/override";
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import {Component, Prop} from 'vue-property-decorator'
import './applicationMarket.less'
import {ApplicationMarketDOI} from "./api/applicationMarketApi";
import { createBEM, createNamespace } from 'src/util/bem';
import Tab from 'src/components/tab/tab';
import Button from 'src/types/iview/Button';
import alertApplicationMarketApiModal from './applicationMarketModal';
import EnumStationType from 'src/enums/enumStationType';
let bem = createBEM('menu-btn');


@Component({name: 'application-market'})
export default class ApplicationMarket extends BasicSearchPage<ApplicationMarketService, ApplicationMarketDOI.RowDataI, ApplicationMarketDOI.QueryRowDataParamsI> {
    @Prop({
        type: Boolean,
        default: false,
    })
    isModal!: boolean

    @override
    renderHead(h) {
        return <div></div>
    }

    
	@override
	loadService () {
		this.service = new ApplicationMarketService(this)
	}

    // async upload() {
    //     let res = await alertApplicationMarketApiModal();
    //     if (res) {
    //         this.service.searchTable()
    //     }
    // }
}